const LOCAL_PASSWORD_VALUE_KEY = 'advoq_local_password_value';
const LOCAL_PASSWORD_USER_KEY = 'advoq_local_password_user_id';
const LOCAL_PASSWORD_VERIFICATION_ID_KEY = 'advoq_local_password_verification_id';
const LOCAL_PASSWORD_VERIFICATION_USER_KEY = 'advoq_local_password_verification_user_id';
const LOCAL_PASSWORD_VERIFICATION_PURPOSE_KEY = 'advoq_local_password_verification_purpose';

function canUseSessionStorage() {
  return typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';
}

export function storeGeneratedLocalPassword(userId, password) {
  if (!canUseSessionStorage() || !userId || !password) return;
  window.sessionStorage.setItem(LOCAL_PASSWORD_USER_KEY, userId);
  window.sessionStorage.setItem(LOCAL_PASSWORD_VALUE_KEY, password);
}

export function readGeneratedLocalPassword(userId) {
  if (!canUseSessionStorage() || !userId) return '';
  if (window.sessionStorage.getItem(LOCAL_PASSWORD_USER_KEY) !== userId) return '';
  return window.sessionStorage.getItem(LOCAL_PASSWORD_VALUE_KEY) || '';
}

export function clearGeneratedLocalPassword(userId) {
  if (!canUseSessionStorage()) return;
  const storedUserId = window.sessionStorage.getItem(LOCAL_PASSWORD_USER_KEY);
  if (userId && storedUserId && storedUserId !== userId) return;
  window.sessionStorage.removeItem(LOCAL_PASSWORD_USER_KEY);
  window.sessionStorage.removeItem(LOCAL_PASSWORD_VALUE_KEY);
}

export function storePasswordVerification(userId, verificationId, purpose) {
  if (!canUseSessionStorage() || !userId || !verificationId || !purpose) return;
  window.sessionStorage.setItem(LOCAL_PASSWORD_VERIFICATION_USER_KEY, userId);
  window.sessionStorage.setItem(LOCAL_PASSWORD_VERIFICATION_ID_KEY, verificationId);
  window.sessionStorage.setItem(LOCAL_PASSWORD_VERIFICATION_PURPOSE_KEY, purpose);
}

export function readPasswordVerification(userId, purpose) {
  if (!canUseSessionStorage() || !userId) return '';
  if (window.sessionStorage.getItem(LOCAL_PASSWORD_VERIFICATION_USER_KEY) !== userId) return '';
  const storedPurpose = window.sessionStorage.getItem(LOCAL_PASSWORD_VERIFICATION_PURPOSE_KEY) || '';
  if (purpose && storedPurpose !== purpose) return '';
  return window.sessionStorage.getItem(LOCAL_PASSWORD_VERIFICATION_ID_KEY) || '';
}

export function clearPasswordVerification(userId, purpose) {
  if (!canUseSessionStorage()) return;
  const storedUserId = window.sessionStorage.getItem(LOCAL_PASSWORD_VERIFICATION_USER_KEY);
  const storedPurpose = window.sessionStorage.getItem(LOCAL_PASSWORD_VERIFICATION_PURPOSE_KEY) || '';
  if (userId && storedUserId && storedUserId !== userId) return;
  if (purpose && storedPurpose && storedPurpose !== purpose) return;
  window.sessionStorage.removeItem(LOCAL_PASSWORD_VERIFICATION_USER_KEY);
  window.sessionStorage.removeItem(LOCAL_PASSWORD_VERIFICATION_ID_KEY);
  window.sessionStorage.removeItem(LOCAL_PASSWORD_VERIFICATION_PURPOSE_KEY);
}
